import FormattedName from 'I18n/components/FormattedName';
import { jsx as _jsx } from "react/jsx-runtime";
const DocumentOwnerCell = ({
  searchResult
}) => {
  const {
    firstName,
    lastName
  } = searchResult.userView.toObject();
  if (!firstName && !lastName) {
    return null;
  }
  return /*#__PURE__*/_jsx("span", {
    "data-vr-display-none": true,
    children: /*#__PURE__*/_jsx(FormattedName, {
      givenName: firstName,
      familyName: lastName
    })
  });
};
export default DocumentOwnerCell;